//
//
//
//
//
//
//
//
//

export default {
  name: 'AppAnnouncer',

  computed: {
    live() {
      return this.$store.state.ui.announcerLive
    },

    content() {
      return this.$store.state.ui.announcer
    }
  }
}
